<template>
  <transition name="fade">
    <div v-if="visible">
      <div v-if="mask" class="toast--mask"></div>
      <div class="toast">
        <div class="toast__content">
          <span class="toast__text">{{ visibleTxt }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  txt: {
    type: String,
    default: ''
  },
  mask: {
    type: Boolean,
    default: false
  },
  duration: {
    type: Number,
    default: 2000
  }
})

const visible = ref(false)
const visibleTxt = ref(props.txt)

const show = () => {
  visible.value = true
  if (props.duration > 0) {
    setTimeout(() => {
      hide()
    }, props.duration)
  }
}

const hide = () => {
  visible.value = false
}

const setText = (val) => {
  visibleTxt.value = val
}

defineExpose({
  show,
  hide,
  setText
})
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10001;
}

.toast--mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
}

.toast__content {
  padding: 12px 20px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
}

.toast__text {
  font-size: 14px;
  color: #fff;
  line-height: 1.5;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
